import Constants from 'core/constants';

const defaultProps = {
  clientId: -1,
  calendarType: 'G',
  dateType: Constants.DATE_ONLY,
  rangeType: 'C',
  periodType: 'D',
};

const convertDateRange = ({ dateRange, shortHand = false } = {}) => {
  if (!dateRange) {
    return null;
  }
  if (shortHand) {
    return {
      k: dateRange.clientId || defaultProps.clientId,
      c: dateRange.calendarType || defaultProps.calendarType,
      t: dateRange.dateType || dateRange.dateRangeType || defaultProps.dateType,
      r: dateRange.rangeType || defaultProps.rangeType,
      p: dateRange.periodType || defaultProps.periodType,
      n: dateRange.number,
      a: dateRange.asOf,
      f: dateRange.first,
      l: dateRange.last,
      z: dateRange.timezone,
    };
  }
  return {
    clientId: dateRange.k || defaultProps.clientId,
    calendarType: dateRange.c || defaultProps.calendarType,
    dateType: dateRange.t || dateRange.dateRangeType || defaultProps.dateType,
    rangeType: dateRange.r || defaultProps.rangeType,
    periodType: dateRange.p || defaultProps.periodType,
    number: dateRange.n,
    asOf: dateRange.a,
    first: dateRange.f,
    last: dateRange.l,
    timezone: dateRange.z,
  };
};
export default convertDateRange;
